'use client';

// Explicitly duplicate the allowed widths from next.config.mjs to mathematically sync with the Cloudflare Firewall
const ALLOWED_WIDTHS = [16, 32, 48, 64, 96, 128, 256, 384, 640, 750, 828, 1080, 1200, 1920];

export default function imgproxyLoader({ src, width, quality }: { src: string, width: number, quality?: number }) {
    // Dynamically clamp the Next.js retina width (e.g. 768px) exactly to the safest mathematically approved CDN Firewall width
    const safeWidth = ALLOWED_WIDTHS.find(w => w >= width) || 1920;

    const sep = src.includes('?') ? '&' : '?';
    return `${src}${sep}w=${safeWidth}&q=${quality || 75}`;
}
